export default __webpack_public_path__ + "static/media/medium-shot-happy-couple-having-fun.72e1de4a.jpg";